module.exports = __webpack_public_path__ + "static/img/1071_big.6c33785.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1071_big.png
// module id = 4Hhm
// module chunks = 1